import axios from "axios";
import { Global } from "../../config/global";


export const handleAutoAsing = async (estado) => {

        let responseData = null;
        let token = localStorage.getItem('token'); //Extraer el token del localStorage.

        //Definir el endpoint de la ruta y realizar la petición.
        let url = Global.url + `user/autoAsignar/${estado}`;

        let config = {
            method: 'post',
            url: url,
            headers: {
                Authorization: `Bearer ${token}`,
                /* 'Content-Type': 'multipart/form-data' */
            },
        };
    
        try {
            const response = await axios.request(config);
            console.log("esta es la respuesta de autoasignarse en la función",response); 
            return response;
        } catch (error) {
            console.log(error);
            throw error;
        }

}